import { createContext, useContext } from 'react';

type SidebarContextType = {
  isSidebarVisible: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType>({
  isSidebarVisible: false,
  toggleSidebar: () => {},
});

export const useSidebar = () => {
  const { isSidebarVisible, toggleSidebar } = useContext(SidebarContext);

  return {
    isSidebarVisible,
    toggleSidebar,
  };
};
